import { render, staticRenderFns } from "./workloginfo.vue?vue&type=template&id=01b27603&scoped=true"
import script from "./workloginfo.vue?vue&type=script&lang=js"
export * from "./workloginfo.vue?vue&type=script&lang=js"
import style0 from "./workloginfo.vue?vue&type=style&index=0&id=01b27603&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b27603",
  null
  
)

export default component.exports